// Hook: GET /api/cases/by-eid/:eId → prototype Matter shape via the
// `fetchMatter` adapter, with fixture fallback for prototype eIDs that
// don't exist in Mongo yet (e.g. "DL-YJF4Q5").

import { useQuery } from "@tanstack/react-query";
import { fetchMatter, type MatterWithClient } from "../api/mock";

export function useMatter(eID: string | undefined) {
  return useQuery<MatterWithClient | null>({
    queryKey: ["matter", eID ?? ""],
    queryFn: () => (eID ? fetchMatter(eID) : Promise.resolve(null)),
    enabled: !!eID,
  });
}
